export default function createDynamicLink(url) {
	let head = document.getElementsByTagName('head')[0],
	cssURL = `${url}/color.less`,
	linkTag = document.createElement('link');
	linkTag.href = cssURL;
	linkTag.setAttribute('rel','stylesheet/less');
	linkTag.setAttribute('type','text/css');
	head.appendChild(linkTag);
}